import game11 from './games/game1-1.png';
import game12 from './games/game1-2.png';
import game13 from './games/game1-3.png';
import game21 from './games/game2-1.png';
import game22 from './games/game2-2.png';
import game23 from './games/game2-3.png';
import game31 from './games/game3-1.png';
import game32 from './games/game3-2.png';
import game33 from './games/game3-3.png';
import game41 from './games/game4-1.png';
import game42 from './games/game4-2.png';
import game43 from './games/game4-3.png';
import game51 from './games/game5-1.png';
import game52 from './games/game5-2.png';
import game53 from './games/game5-3.png';
import game61 from './games/game6-1.png';
import game62 from './games/game6-2.png';
import game63 from './games/game6-3.png';
import game71 from './games/game7-1.png';
import game72 from './games/game7-2.png';
import game73 from './games/game7-3.png';
import game81 from './games/game8-1.png';
import game82 from './games/game8-2.png';
import game83 from './games/game8-3.png';

export const gameImages = {
  game11,
  game12,
  game13,
  game21,
  game22,
  game23,
  game31,
  game32,
  game33,
  game41,
  game42,
  game43,
  game51,
  game52,
  game53,
  game61,
  game62,
  game63,
  game71,
  game72,
  game73,
  game81,
  game82,
  game83,
} as const;
